import { useAnalytics } from "@/stores";

export const analytics = {
  install(app) {
    const analyticsStore = useAnalytics();

    // List of elements we want to ignore clicks on
    const ignoredElements = new Set([
      "HTML",
      "BODY",
      "DIV", // Generic containers
    ]);

    // Get meaningful text content from an element
    const getElementText = (element) => {
      // If it's a button or link, prefer aria-label or title
      const accessibleText =
        element.getAttribute("aria-label") || element.getAttribute("title");
      if (accessibleText) return accessibleText;

      // For inputs, use placeholder or value
      if (element instanceof HTMLInputElement) {
        return element.placeholder || element.value || null;
      }

      // Get direct text content, excluding child elements
      const text = Array.from(element.childNodes)
        .filter((node) => node.nodeType === Node.TEXT_NODE)
        .map((node) => node.textContent.trim())
        .join(" ")
        .trim();

      return text || null;
    };

    // Get element details we want to track
    const getElementDetails = (element) => {
      return {
        // tag: element.tagName,
        id: element.id || null,
        // classes: Array.from(element.classList),
        text: getElementText(element),
        href: element instanceof HTMLAnchorElement ? element.href : null,
        type: element.type || null,
        name: element.name || null,
      };
    };

    // Find the most specific trackable element
    const findTrackableElement = (element) => {
      let current = element;

      while (current && current !== document.body) {
        // If element has tracking data, return it immediately
        if (current.hasAttribute("data-track")) {
          return current;
        }

        // Otherwise, continue to parent
        current = current.parentElement;
      }

      return null;
    };

    // Handle click events
    const handleClick = (event) => {
      const trackableElement = findTrackableElement(event.target);
      if (!trackableElement) return;

      // Get any custom tracking data
      const trackData = trackableElement.getAttribute("data-track");
      let customData = {};
      if (trackData) {
        try {
          customData = JSON.parse(trackData);
        } catch (e) {
          customData = { value: trackData };
        }
      }

      // Merge custom data with element details
      const elementDetails = {
        ...getElementDetails(trackableElement),
        ...customData,
      };

      // Create click event
      const clickEvent = {
        type: "click",
        element: elementDetails,
      };

      // Add event to buffer
      analyticsStore.addEvent(clickEvent);
    };

    // Add global click listener
    document.addEventListener("click", handleClick, true);

    // Clean up on app unmount
    app.config.globalProperties.$analytics = analyticsStore;
  },
};
